"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultExecutionContext = void 0;
const uuid = require("uuid");
const logger_1 = require("@leavy/logger");
class DefaultExecutionContext {
    constructor(logger = new logger_1.VoidLogger(), invokingContext) {
        this.executionId = uuid.v4();
        this.logger = logger;
        if (invokingContext) {
            this.correlationId = invokingContext.correlationId;
            this.actorId = invokingContext.actorId;
            this.ambientValues = invokingContext.ambientValues;
        }
        else {
            this.correlationId = this.executionId;
        }
    }
}
exports.DefaultExecutionContext = DefaultExecutionContext;
//# sourceMappingURL=Context.js.map